import { LegalPersonTags } from '@dealstack/shared/lib/generated';

export enum REGISTRATION_DETAILS_FORM_FIELDS {
	jurisdiction_name = 'jurisdiction_name',
	jurisdiction_language = 'jurisdiction_language',
	legal_form_id = 'legal_form_id',
	registration_number = 'registration_number',
	registered_name = 'registered_name',
}

export interface RegistrationDetailsFormValues {
	[REGISTRATION_DETAILS_FORM_FIELDS.jurisdiction_name]: string | null;
	[REGISTRATION_DETAILS_FORM_FIELDS.jurisdiction_language]: string | null;
	[REGISTRATION_DETAILS_FORM_FIELDS.legal_form_id]: string | null;
	[REGISTRATION_DETAILS_FORM_FIELDS.registration_number]: string | null;
	[REGISTRATION_DETAILS_FORM_FIELDS.registered_name]: string | null;
}

export enum CLASSIFIERS_FORM_FIELDS {
	display_name = 'display_name',
	tags = 'tags',
}

export interface ClassifiersFormValues {
	[CLASSIFIERS_FORM_FIELDS.display_name]: string | null;
	[CLASSIFIERS_FORM_FIELDS.tags]: Array<LegalPersonTags>;
}
